import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=72ac1358&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=72ac1358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac1358",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NotFound.vue
// module id = 169
// module chunks = 0